import { UPDATE_LABEL_POSITION } from "./labelPositionReducer"

export const updateLabelPosition = (info) => ({
    type: UPDATE_LABEL_POSITION,
    payload: info
})